var map = {
	"./b026/nav/nav": [
		663,
		28
	],
	"./b027site/nav/nav": [
		667,
		24
	],
	"./b027sport/nav/nav": [
		671,
		20
	],
	"./bet365luck/nav/nav": [
		673,
		18
	],
	"./betl/nav/nav": [
		677,
		14
	],
	"./common/nav/nav": [
		681,
		10
	],
	"./taiyangcheng018/nav/nav": [
		683,
		8
	],
	"./veniceman/nav/nav": [
		687,
		4
	],
	"./yongligao/nav/nav": [
		691,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 657;


//////////////////
// WEBPACK FOOTER
// ./src/components/different lazy ^\.\/.*\/nav\/nav$
// module id = 657
// module chunks = 31